import React from "react";

const ListItem = (
  props: React.DetailedHTMLProps<
    React.LiHTMLAttributes<HTMLLIElement>,
    HTMLLIElement
  >,
) => {
  const { className, children, ...rest } = props;

  return (
    <li
      className={`cursor-pointer border-y-[1px] border-y-rss-border bg-gradient-to-r from-white to-white p-5 py-5 font-bold leading-5 text-rss-dark-gray transition-all duration-300 hover:from-[#F3E9FF] hover:to-white ${className}`}
      {...rest}
    >
      {children}
    </li>
  );
};

export default ListItem;
